import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ThumbsUpIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#clip0_588_40322)",
                            children: _jsx("path", {
                                d: "M7.82 22H3.7A1.7 1.7 0 012 20.3V9.66A1.7 1.7 0 013.7 8h3.82a2.56 2.56 0 001.82-1.33l1.07-2.81A3.19 3.19 0 0113.3 2h1.23a2 2 0 012 2v4h2.61a2.91 2.91 0 012.8 3.66l-1 4.21a5.81 5.81 0 01-5.67 4.48H9v.05a1.35 1.35 0 01-.24 1.14 1.22 1.22 0 01-.94.46zM4 20h3V10H4v10zm5-1.6h6.24A3.81 3.81 0 0019 15.46l1-4.24a.91.91 0 00-.88-1.17L16.4 10a2 2 0 01-1.91-2V4H13.3a1.17 1.17 0 00-1.06.66l-1.17 3A5.3 5.3 0 019 9.58v8.82z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "clip0_588_40322",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ThumbsUpIcon.isCarinaIcon = true;
export default ThumbsUpIcon;
